import { useState } from 'react';

// Declaração do gtag para TypeScript
declare global {
  interface Window {
    gtag?: (...args: any[]) => void;
    gtag_report_conversion?: (url?: string) => boolean;
  }
}

export default function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    service: '',
    message: '',
  });
  const [charCount, setCharCount] = useState(0);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    if (name === 'message') {
      if (value.length <= 500) {
        setFormData({ ...formData, [name]: value });
        setCharCount(value.length);
      }
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!formData.name || !formData.phone || !formData.service) {
      alert('Por favor, preencha todos os campos obrigatórios.');
      return;
    }

    // Rastrear conversão no Google Ads
    if (window.gtag_report_conversion) {
      window.gtag_report_conversion();
    }

    // Criar mensagem formatada para WhatsApp
    let message = `*Solicitação de Orçamento - JB Pinturas*\n\n`;
    message += `*Nome:* ${formData.name}\n`;
    message += `*Telefone:* ${formData.phone}\n`;
    if (formData.email) {
      message += `*E-mail:* ${formData.email}\n`;
    }
    message += `*Serviço:* ${formData.service}\n`;
    if (formData.message) {
      message += `*Mensagem:* ${formData.message}`;
    }

    // Codificar mensagem para URL
    const encodedMessage = encodeURIComponent(message);
    const whatsappUrl = `https://wa.me/5512981564801?text=${encodedMessage}`;
    
    // Abrir WhatsApp em nova aba
    window.open(whatsappUrl, '_blank');
    
    // Limpar formulário
    setFormData({ name: '', phone: '', email: '', service: '', message: '' });
    setCharCount(0);
  };

  const handleWhatsAppHeaderClick = () => {
    // Rastrear conversão no Google Ads
    if (window.gtag_report_conversion) {
      window.gtag_report_conversion();
    }
  };

  const handlePhoneClick = () => {
    // Rastrear conversão no Google Ads
    if (window.gtag_report_conversion) {
      window.gtag_report_conversion();
    }
  };

  const handleWhatsAppSidebarClick = () => {
    // Rastrear conversão no Google Ads
    if (window.gtag_report_conversion) {
      window.gtag_report_conversion();
    }
  };

  return (
    <section id="contato" className="py-20 bg-gradient-to-br from-orange-500 to-yellow-500">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16 text-white">
          <div className="w-20 h-20 bg-white rounded-full flex items-center justify-center mx-auto mb-6">
            <i className="ri-whatsapp-line text-green-500 text-3xl"></i>
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold mb-4">Entre em Contato</h2>
          <h3 className="text-3xl font-semibold mb-8">Solicite seu Orçamento Gratuito</h3>
          <a
            href="https://wa.me/5512981564801"
            target="_blank"
            rel="noopener noreferrer"
            onClick={handleWhatsAppHeaderClick}
            className="bg-green-500 hover:bg-green-600 text-white px-8 py-4 rounded-lg font-bold text-xl transition-all transform hover:scale-105 inline-flex items-center space-x-2 whitespace-nowrap shadow-lg"
          >
            <i className="ri-whatsapp-line"></i>
            <span>Chame pelo WhatsApp</span>
          </a>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
          <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 text-white">
            <h4 className="text-2xl font-bold mb-6">Fale Conosco</h4>
            <h5 className="text-xl font-semibold mb-8">ATENDIMENTO PERSONALIZADO</h5>

            <div className="text-center mb-8">
              <div className="w-32 h-32 bg-white/20 rounded-full flex items-center justify-center mx-auto animate-pulse">
                <i className="ri-paint-brush-line text-6xl"></i>
              </div>
            </div>

            <div className="space-y-4">
              <a
                href="tel:+5512981564801"
                onClick={handlePhoneClick}
                className="w-full flex items-center justify-center space-x-3 bg-white/20 backdrop-blur-sm rounded-lg p-4 hover:bg-white/30 transition-colors cursor-pointer"
              >
                <i className="ri-phone-line text-2xl"></i>
                <span className="text-lg font-semibold">(12) 98156-4801</span>
              </a>
              <a
                href="https://wa.me/5512981564801"
                target="_blank"
                rel="noopener noreferrer"
                onClick={handleWhatsAppSidebarClick}
                className="w-full flex items-center justify-center space-x-3 bg-green-500/80 backdrop-blur-sm rounded-lg p-4 hover:bg-green-500 transition-colors cursor-pointer"
              >
                <i className="ri-whatsapp-line text-2xl"></i>
                <span className="text-lg font-semibold">(12) 98156-4801</span>
              </a>
            </div>

            <div className="mt-8 p-6 bg-white/10 rounded-lg">
              <h6 className="font-bold mb-2">📍 Localização</h6>
              <p>São José dos Campos - SP</p>
              <p className="mt-4">
                <strong>CNPJ:</strong> 29.017.962/0001-35
              </p>
            </div>
          </div>

          <div className="bg-white rounded-2xl p-8 shadow-2xl">
            <h4 className="text-2xl font-bold text-gray-800 mb-6 text-center">
              Solicite seu Orçamento Grátis
            </h4>
            <form onSubmit={handleSubmit}>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                <div>
                  <label className="block text-gray-700 font-medium mb-2">Nome Completo *</label>
                  <input
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:border-orange-500 transition-colors text-sm"
                    placeholder="Seu nome completo"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                  />
                </div>
                <div>
                  <label className="block text-gray-700 font-medium mb-2">Telefone/WhatsApp *</label>
                  <input
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:border-orange-500 transition-colors text-sm"
                    placeholder="(12) 99999-9999"
                    type="tel"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                  />
                </div>
              </div>

              <div className="mb-4">
                <label className="block text-gray-700 font-medium mb-2">E-mail</label>
                <input
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:border-orange-500 transition-colors text-sm"
                  placeholder="seu@email.com"
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                />
              </div>

              <div className="mb-4">
                <label className="block text-gray-700 font-medium mb-2">Tipo de Serviço *</label>
                <div className="relative">
                  <select
                    name="service"
                    required
                    className="w-full px-4 py-3 pr-8 border border-gray-300 rounded-lg focus:outline-none focus:border-orange-500 transition-colors appearance-none text-sm"
                    value={formData.service}
                    onChange={handleChange}
                  >
                    <option value="">Selecione o serviço desejado</option>
                    <option value="Pintura Residencial">Pintura Residencial</option>
                    <option value="Pintura Comercial">Pintura Comercial</option>
                    <option value="Pintura de Prédios">Pintura de Prédios</option>
                    <option value="Texturas Decorativas">Texturas Decorativas</option>
                    <option value="Reparos em Gesso">Reparos em Gesso</option>
                    <option value="Reparos Gerais">Reparos Gerais</option>
                    <option value="Outro serviço">Outro serviço</option>
                  </select>
                  <i className="ri-arrow-down-s-line absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 pointer-events-none"></i>
                </div>
              </div>

              <div className="mb-6">
                <label className="block text-gray-700 font-medium mb-2">Mensagem</label>
                <textarea
                  name="message"
                  rows={4}
                  maxLength={500}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:border-orange-500 transition-colors resize-none text-sm"
                  placeholder="Descreva seu projeto ou dúvida (máximo 500 caracteres)"
                  value={formData.message}
                  onChange={handleChange}
                ></textarea>
                <div className="text-right text-xs text-gray-500 mt-1">{charCount}/500 caracteres</div>
              </div>

              <button
                type="submit"
                className="w-full bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 text-white px-6 py-4 rounded-lg font-bold text-lg transition-all transform hover:scale-105 whitespace-nowrap cursor-pointer flex items-center justify-center space-x-2"
              >
                <i className="ri-whatsapp-line text-xl"></i>
                <span>Enviar pelo WhatsApp</span>
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}
